<template>
    <va-dropdown
        class="profile-dropdown"
        v-model="isShown"
        boundary-body
        position="bottom"
        :offset="[0, 13]"
    >
        <template #anchor>
            <span class="profile-dropdown__anchor">
                <slot />
                <va-icon
                    class="px-2"
                    :name="isShown ? 'angle_up' : 'angle_down'"
                    :color="theme.primary"
                />
            </span>
        </template>

        <va-dropdown-content class="profile-dropdown__content">
            <va-list-item
                v-for="option in options"
                :key="option.name"
                class="profile-dropdown__list-item"
                @click="doClick(option.type)"
            >
                <div class="profile-dropdown__item">
                    {{ $t(`user.${option.name}`) }}
                </div>
            </va-list-item>
        </va-dropdown-content>
    </va-dropdown>

    <vxe-modal
        title="查看密钥"
        v-model="formWin.showWin"
        width="600"
        height="140"
    >
        <template #default>
            <vxe-form ref="rForm" :data="formWin.data">
                <vxe-form-item
                    title="密钥"
                    field="strCryptKey"
                    span="24"
                    :item-render="{}"
                >
                    <template #default>
                        <vxe-input
                            v-model="formWin.data.strCryptKey"
                            placeholder="密钥"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
            </vxe-form>
        </template>
    </vxe-modal>
</template>

<script>
import { useGlobalConfig } from "vuestic-ui";
import { reactive } from "vue";
import { VXETable } from "vxe-table";
import Qs from "qs";

export default {
    name: "profile-section",

    data() {
        const formWin = reactive({
            showWin: false,
            data: {
                oldPwd: "",
                newPwd1: "",
                newPwd2: "",
                strCryptKey: "",
            },
            formRules: {
                oldPwd: [{ required: true, message: "原密码不能为空" }],
                newPwd1: [{ required: true, message: "新密码不能为空" }],
                newPwd2: [{ required: true, message: "确认密码不能为空" }],
            },
        });

        return {
            isShown: false,
            formWin,
        };
    },

    props: {
        options: {
            type: Array,
            default: () => [
                {
                    name: "profile",
                    redirectTo: "",
                    type: "3",
                },
                {
                    name: "viewCryptkey",
                    redirectTo: "",
                    type: "2",
                },
                {
                    name: "logout",
                    redirectTo: "single-login",
                    type: "1",
                },
            ],
        },
    },

    computed: {
        theme() {
            return useGlobalConfig().getGlobalConfig();
        },

        getUserName() {
            return this.$store.state.userName;
        },

        getJobZb() {
            return this.$store.state.jobZb;
        },

        getJobName() {
            return this.$store.state.jobName;
        },

        getUserEmail() {
            return this.$store.state.email;
        },

        getUserId() {
            return this.$store.state.userID;
        },
    },

    methods: {
        doClick(type) {
            this.isShown = false;

            if (type == "1") {
                // 退出
                this.$store.commit("logoutUserInfo");
                this.$router.push({ name: "single-login" });
            } else if (type == "2") {
                // 查看密钥
                this.loadData();
                this.formWin.showWin = true;
            } else if (type == "3") {
                // 个人信息
                this.$router.push({ name: "personalCenter" });
            }
        },

        async changePwd() {
            const $rForm = this.$refs.rForm;
            const formErrMap = await $rForm.validate();

            if (formErrMap) {
                return;
            }

            const params = {
                UserId: this.getUserId,
                OldPwd: this.formWin.data.oldPwd,
                NewPwd1: this.formWin.data.newPwd1,
                NewPwd2: this.formWin.data.newPwd2,
            };

            this.$api.systemManageAPI
                .updatePassword(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }

                    VXETable.modal.message({
                        content: "密码修改成功，请重新登录",
                        status: "success",
                    });

                    this.$store.commit("logoutUserInfo");
                    this.$router.push({ name: "single-login" });
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        closeWin() {
            this.isShown = false;
        },

        loadData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 1,
                searchKey: [],
            };

            this.$api.systemManageAPI
                .getCryptKey(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }

                    this.formWin.data.strCryptKey = res.data.Data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>

<style lang="scss">
.profile-dropdown {
    cursor: pointer;

    &__item {
        cursor: pointer;
    }
}
</style>
